import { $t } from '@previo/core'
import { PDateRangePickerFastChoice, type PDateRangePickerFastChoiceItem } from './types'

export const termChoicesList: PDateRangePickerFastChoiceItem[] = [
  {
    type: PDateRangePickerFastChoice.YESTERDAY,
    name: $t('Yesterday'),
  },
  {
    type: PDateRangePickerFastChoice.TODAY,
    name: $t('Today'),
  },
  {
    type: PDateRangePickerFastChoice.TOMORROW,
    name: $t('Tomorrow'),
  },
  {
    type: PDateRangePickerFastChoice.LAST_WEEK,
    name: $t('Last week'),
  },
  {
    type: PDateRangePickerFastChoice.THIS_WEEK,
    name: $t('This week'),
  },
  {
    type: PDateRangePickerFastChoice.NEXT_WEEK,
    name: $t('Next week'),
  },
  {
    type: PDateRangePickerFastChoice.LAST_MONTH,
    name: $t('Last month'),
  },
  {
    type: PDateRangePickerFastChoice.THIS_MONTH,
    name: $t('This month'),
  },
  {
    type: PDateRangePickerFastChoice.NEXT_MONTH,
    name: $t('Next month'),
  },
  {
    type: PDateRangePickerFastChoice.LAST_YEAR,
    name: $t('Last year'),
  },
  {
    type: PDateRangePickerFastChoice.THIS_YEAR,
    name: $t('This year'),
  },
  {
    type: PDateRangePickerFastChoice.NEXT_YEAR,
    name: $t('Next year'),
  },
]
